// extracted by mini-css-extract-plugin
export default {"container":"ApplicationTitle_container__4qoC0"};